import React, { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import CustomCheckbox from "../../atoms/CustomCheckbox";
import Buttons from "../../atoms/Buttons";
import { ModalOverlay } from "../../atoms/Modal";
import "./lumpsumallowances.scss";
import { RA_STEPS_IDENTIFIERS } from "../../constants/constants";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const LumpSumAllowances = (props) => {
  const { pension } = useSelector(
    (state) => state.retirementApplication // eslint-disable-line
  );

  const navigate = useNavigate();
  const [lumpSumMoreThanAllowance, setLumpSumMoreThanAllowance] =
    useState(false);
  const [selectedCheck, setSelectedCheck] = useState([]);
  const [selectedRadio, setSelectedRadio] = useState(false);
  const { editingPage, setEditingPage } = props;

  useEffect(() => {
    if (
      pension?.expectToReceiveLumpSumFromUkPensionProvider ||
      pension?.notReceivedLumpSumFromPensionProvider
    ) {
      setSelectedRadio("notReceivedLumpSumFromPensionProvider");
      setSelectedCheck(["notReceivedLumpSumFromPensionProvider"]);
    }
  }, []);

  const checkBoxData = [
    {
      checkboxName: "notReceivedLumpSumFromPensionProvider",
      label:
        "The total of any tax-free lump sums taken or being taken from any UK pensions(s), including my TPT pension, does not exceed the standard lump sum allowance.",
    },
    {
      checkboxName: "receivedLumpSumFromUkPensionProvider",
      label: (
        <>
          <p className="">
            The total of current and previous tax-free lump sums from my UK
            pensions are expected to exceed the standard lump sum allowance.
          </p>
        </>
      ),
    },
  ];

  const handleBack = () => {
    props.makeInitialStepper(true);
  };
  const handleContinue = () => {
    props.nextStepIndentifier(
      RA_STEPS_IDENTIFIERS.RA_LUMP_SUM_ALLOWANCES,
      [...selectedCheck, selectedRadio],
      "",
      editingPage //eslint-disable-line
    );
    setEditingPage("");
  };
  return (
    <>
      <Card className="application-step">
        <Card.Body className="lump-sum-allowances">
          <Row>
            <Col md={12} className="mb-fourty">
              <p className="guidance">Lump sum allowances</p>
            </Col>
          </Row>
          <Row className="ourter-bg">
            <Col md={12} className="bg-text">
              We need to check that your tax-free lump sum is within the limits
              set by HM Revenue & Customs (HMRC). Please answer the following
              question in relation to all of your previous and current UK
              pensions, including your TPT pension you are taking now.
            </Col>
          </Row>
          <br />
          <Row className="ourter-bg">
            <Col md={12} className="bg-text">
              Tick <span className="fw-bold">one</span> box only.
            </Col>
          </Row>

          <Row className="pwd">
            <Col md={12} className="bg-text">
              <div className="check-box">
                {checkBoxData?.map((item, index) => {
                  return (
                    <div key={index} className="margin-between-items">
                      <div>
                        <CustomCheckbox
                          name={"lumps"}
                          label={item.label}
                          variantName="custom-checkbox mt-3"
                          checked={selectedRadio === item.checkboxName}
                          onChange={() => {
                            setSelectedRadio(item?.checkboxName);
                            if (
                              item?.checkboxName ===
                              "receivedLumpSumFromUkPensionProvider"
                            ) {
                              setLumpSumMoreThanAllowance(true);
                              setSelectedCheck([]);
                            } else if (
                              item?.checkboxName ===
                              "notReceivedLumpSumFromPensionProvider"
                            )
                              setSelectedCheck([item?.checkboxName]);
                          }}
                        />
                      </div>
                    </div>
                  );
                })}
              </div>
              <div>
                Please visit the{" "}
                <Buttons
                  name="tax and savings"
                  className="tertiary savings-link"
                  handleClick={() => {
                    navigate("/learn/support/tax-savings/");
                  }} //eslint-disable-line
                ></Buttons>{" "}
                page for further details about the lump sum allowance.
              </div>
            </Col>
            <Col md={6}></Col>
          </Row>

          <div className="footer-btn-container">
            <Buttons
              handleClick={handleBack}
              className="secondary back-btn"
              name="Back"
            />

            <Buttons
              handleClick={() => handleContinue()}
              className="primary"
              name="Continue"
              disabled={selectedCheck.length === 0 || selectedRadio === false}
            />
          </div>
        </Card.Body>
      </Card>
      <ModalOverlay
        popup="expectedLumpSumMoreThanAllowance"
        show={lumpSumMoreThanAllowance}
        headTitle="Lump sums above the lump sum allowance"
        description={
          <>
            <p>
              You believe that your total pension lump sums will exceed the
              current lump sum allowance (LSA).
            </p>
            <p>
              To calculate your correct tax-free lump sum, if any, we will need
              information about the lump sum pension payments you have received
              or are due to receive from other UK pension schemes (excluding
              this one).
            </p>
          </>
        }
        subDescription={
          <>
            <p className="fw-bold">
              Please visit the{" "}
              <Link
                to="/messages-and-documents?tab=schemeDocuments"
                className="getintouch-link"
              >
                Scheme documents
              </Link>{" "}
              area in your Account for a Lump Sum Allowance (LSA) form.
            </p>
            <p>
              You should upload your completed LSA form to TPT at{" "}
              <span
                className="getintouch-link"
                onClick={() => navigate("/get-in-touch/")}
              >
                Get in touch
              </span>
              .
            </p>
            <p>
              We will then be able to create a personalised quote for you,
              together with a retirement application form for you to proceed to
              take your pension.
            </p>
          </>
        }
        btnSendName="Lump sum allowance form"
        btnCancelName="BACK"
        onHide={(e) => {
          if (e !== undefined) {
            e.preventDefault();
          }
          setLumpSumMoreThanAllowance(false);
          setSelectedRadio(null);
        }}
        handleSendLink={() => {
          navigate("/messages-and-documents?tab=schemeDocuments", {
            state: {
              disabled: true,
            },
          });
          setLumpSumMoreThanAllowance(false);
        }}
      />
    </>
  );
};

export default LumpSumAllowances;
